export default function buildHtsValue(currentValue) {
  let newValue = currentValue.slice();
  if (newValue.length === 4) {
    newValue = `${newValue}.`;
  } else if (newValue.length === 7) {
    newValue = `${newValue}.`;
  }
  return newValue;
}
